<template>
    <div class="story-maker-sticker-menu-music">
        <audio @canplaythrough="(e) => e.target.volume = '0.5'" :ref="`music-preview`"></audio>
        <div class="header-menu">
            <p>{{ $t('dash.post-creator.story.music-title') }}</p>
        </div>
        <div class="search-bar">
            <i class="fa-regular fa-magnifying-glass"></i>
            <input :placeholder="$t('dash.post-creator.overlay.search-music')" v-model="models.search">
        </div>
        <div v-if="!models.search" class="navigation">
            <div v-for="[key, feed] in Object.entries(feeds)" @click="selectFeed(key)" class="item-nav" :class="{active: selectedFeed === key}">{{ feed.name }}</div>
        </div>

        <div class="list-item hide-scrollbar">
            <span class="loader" v-if="stateLoader"></span>
            <div class="item" v-else v-for="(music,index) in (models.search.length ? musics : dataInstagramDefault.musics[selectedFeed])" @click="selectMusic(music)" :key="`music${index}`">
                <img :src="music.track ? music.track.cover_artwork_thumbnail_uri : music.original_sound.ig_artist.profile_pic_url">

                <div class="info">
                    <h5>{{ music.track ? music.track.title : music.original_sound.original_audio_title }}</h5>
                    <p>{{`${music.track ? music.track.display_artist : music.original_sound.ig_artist.full_name} • ${Math.floor((music.track || music.original_sound).duration_in_ms / 60000)}:${(('0' + Math.floor(((music.track || music.original_sound).duration_in_ms % 60000) / 1000)).slice(-2))}`}}</p>
                </div>
               
                <div class="btn-control">
                    <div class="circle" @click.stop="toggleMusic(music)" :class="{play : urlMusicPlaying == (music.track || music.original_sound).progressive_download_url}">
                      
                    </div>
                </div>
            </div>    
        </div>
    </div>
</template>
<script>
    import store from '@/store/index.js';
    import minxinPost from '@/components/mixins/Posts.vue'

    export default {
        mixins: [minxinPost],

        props: {
            dataInstagramDefault: Object,
        },
        
        data() {
            return {
                models: {
                    search: ''
                },
                musics: [],
                selectedFeed: 'forYou',
                stateLoader: false,
                timeoutInitSearch: null,
                urlMusicPlaying: null,
            }
        },

        methods: {
            async searchMusic() {
                this.pauseMusic()
                if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
                this.stateLoader = false
                if(!this.models.search) return
                this.stateLoader = true
                this.timeoutInitSearch = setTimeout(async () => {
                    let page = this.pagesSelected.find(p => p.network == 'instagram' && p.story_config && p.story_config.created)
                    this.musics = []
                    if (page) {
                        this.stateLoader = true
                        this.musics = (await this.getMusicInstagram(page.id, this.models.search)).body.musics
                        this.stateLoader = false
                    }
                },1000)
            },

            async selectMusic(music) {
                if (this.urlMusicPlaying) this.toggleMusic()
                this.$emit('addSticker','music', {
                    data: {
                        music
                    }
                })
            },

            selectFeed(feed) {
                this.selectedFeed = feed;
            },

            toggleMusic(music) {
                let audio = this.$refs['music-preview'];

                if (!music) {
                    this.urlMusicPlaying = null;
                    audio.pause();
                    return;
                }

                if ((music.track || music.original_sound).progressive_download_url === audio.src) {
                    if (audio.paused) {
                        audio.play();
                        this.urlMusicPlaying = (music.track || music.original_sound).progressive_download_url;
                    } else {
                        audio.pause();
                        this.urlMusicPlaying = null;
                    }
                } else {
                    audio.src = (music.track || music.original_sound).progressive_download_url;
                    audio.currentTime = music.track ? music.track.highlight_start_times_in_ms[0] / 1000 : 0;
                    this.urlMusicPlaying = (music.track || music.original_sound).progressive_download_url;
                    audio.play();
                }
            },

            pauseMusic() {
                let audio = this.$refs['music-preview'];
                audio.pause();
                this.urlMusicPlaying = null;
            }
        },

        watch: {
            ['models.search'](newValue, oldValue) {
                this.searchMusic()  
            },
        },

        computed: {
            feeds() {
                return {
                    forYou: { name: this.$t('dash.post-creator.music.for-you') },
                    topTrends: { name: this.$t('dash.post-creator.music.popular') },
                }
            },

            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>